import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import styles from "./CookieSettings.module.css";

export default function CookieSettings({ onOpenSettings }) {
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const cookieConsent = localStorage.getItem("cookieConsent");
      setHasConsent(!!cookieConsent);
    };

    checkConsent();

    window.addEventListener("storage", checkConsent);

    return () => {
      window.removeEventListener("storage", checkConsent);
    };
  }, []);

  const handleOpenSettings = () => {
    if (onOpenSettings) {
      onOpenSettings();
    }
  };

  if (!hasConsent) return null;

  return (
    <button
      onClick={handleOpenSettings}
      className={styles.cookieButton}
      title="Cookie Settings"
      aria-label="Open cookie settings"
    >
      <Cookie size={16} />
    </button>
  );
}
